import React, {useState} from 'react';
import Header from '../../layout/Header';
import SideBg from '../../layout/SideBg';
import MainRoutes from '../../routes/MainRoutes';
import './MainContainer.scss';
import ProjectsModal from '../../features/Projects/ProjectsModal/ProjectsModal';
import CompaniesPopup from '../../features/Companies/CompaniesPopup/CompaniesPopup';
import MailingPopup from '../../features/Mailing/MailingPopup/MailingPopup';
import SupportPopup from '../../features/Support/SupportPopup';
import ReviewPopup from '../../features/Components/ReviewPopup/ReviewPopup';

import Preloader from '../../features/Components/Preloader';
import Preparing from '../../features/Components/Preparing';
import ConfirmPopup from '../../features/Components/ConfirmPopup';
import UserEdit from '../../features/Profile/UserEdit/UserEdit';
import VideoPopup from "../../features/Components/VideoPopup";
import ImagesChatPopup from "../../features/Components/ImagesChatPopup";
import EmployeesMultiAdd from "../../features/Components/EmployeesMultiAdd/EmployeesMultiAdd";
import ChangeDocStatus from "../../features/Components/ChangeDocStatus/ChangeDocStatus";

const MainContainer = () => {
    const [menuOpen, setMenuOpen] = useState(() => {
        const savedShortMenu = localStorage.getItem('shortMenu');
        return savedShortMenu === 'true';
    });

    return (
        <>
            <Header/>
            <div className='page_wrapper'>
                <SideBg menuOpen={menuOpen} setMenuOpen={setMenuOpen}/>
                <main className={menuOpen ? 'menu-open' : ''}>
                    <MainRoutes/>
                </main>
            </div>
            <ProjectsModal/>
            <CompaniesPopup/>
            <MailingPopup/>
            <SupportPopup/>
            <ReviewPopup/>
            <Preloader/>
            <Preparing/>
            <ConfirmPopup/>
            <UserEdit/>
            <VideoPopup/>
            <ImagesChatPopup/>
            <EmployeesMultiAdd/>
            <ChangeDocStatus/>
        </>
    );
};

export default MainContainer;
